import { Color, PolylineDashMaterialProperty } from "cesium"

export const airscopeColorHex = "#FAA21B"
export const airscopeColor: Color = Color.fromCssColorString(airscopeColorHex)
export const airscopeDashed = new PolylineDashMaterialProperty({
  color: airscopeColor.withAlpha(0.9),
})
